import AnimatedNumber from '@components/Animation/AnimatedNumber';
import RainbowLoader from '@components/Loaders/RainbowLoader';
import { CardFocusTitle, GridCard } from '@components/GridCards/Common.styled';
import { useStore } from '@store/appStore';
import { useI18n } from '@i18n/useI18n';
import { useEffect, useState } from 'react';
import BackgroundGraph from '../../GridCards/BackgroundGraph';
import { AbsenceContainer, AbsencePraise, Content, Export, Pin, TooltipContainer } from './CourseStats.styled';
import PinIcon from '@assets/svg/pin.svg';
import ExcelIcon from '@assets/svg/excel.svg';
import moment from 'moment';
import { ExportCourseStatisticExcel } from '@utils/exports/exportCourseStatistic';
import Tooltip from "@components/Tooltips/Tooltip";
import { ShowabsenceOrAttendance } from '@utils/percentageTools';

interface IProps {
  teacher?: boolean,
  course?: any,
  pin?: (id, pin) => any,
  pinnedCourses?: any
}

export const CourseStats = (props: IProps) => {
  const i18n = useI18n();
  const { settings, adminSelection, filterDate, client, systemSettings } = useStore();
  const [dataPoints, setDataPoints] = useState(null);
  const [days, setDays] = useState([]);
  const [loading, setLoading] = useState(false);
  const [downloading, setDownloading] = useState(false)

  useEffect(() => {
    if (props.course.days && props.course.days.length > 0) {
      let days = []
      let d = moment(props.course.days[0].date)
      days.push(d.format("DD MMM"))

      if (props.course.days.length > 4) {
        d = moment(props.course.days[Math.floor(props.course.days.length / 2)].date)
        days.push(d.format("DD MMM"))
      }

      d = moment(props.course.days[props.course.days.length - 1].date)
      days.push(d.format("DD MMM"))
      setDays(days)

      let dataP = props.course.days.map(a => a.lessonPercentage)
      setDataPoints(dataP)
    }
  }, [props.course.days])

  const ExportCSV = async (courseId) => {
    if (!downloading) {
      setDownloading(true)
      try {
        const includeDurations = systemSettings?.find((setting) => setting.APP_Setting_ID === 107)?.value?.toLowerCase() === 'true';
        let exportText = { subject: i18n.t('subject'), duration: i18n.t('duration'), courseDuration: i18n.t('course-duration'), totalDuration: i18n.t('total-duration'), absenceDuration: i18n.t('absence-duration'), courseAbsenceDuration: i18n.t('course-absence-duration'), totalAbsenceDuration: i18n.t('total-absence-duration'), percentageLabel: i18n.t(settings.SHOWPRESENCE ? 'attendance-percentage' : 'absence-percentage'), filename: props.course.name.replaceAll(" ", "_") + "_" + (filterDate.from === null ? "01-01-2020" : moment(filterDate.from).format("DD-MM-YYYY")) + "_" + (filterDate.to === null ? moment().format("DD-MM-YYYY") : moment(filterDate.to).format("DD-MM-YYYY")), tabname: props.course.name, col1: i18n.t('export-col1'), col2: i18n.t('export-col2'), col3: i18n.t('export-col3'), col4: i18n.t(settings.SHOWPRESENCE?'export-col4-attendance':'export-col4'), col5: i18n.t(settings.SHOWPRESENCE?'export-col5-attendance':'export-col5') }
        if (filterDate.from !== null) {
          await ExportCourseStatisticExcel(courseId, moment(filterDate.from), moment(filterDate.to), exportText, settings.USEMERIT, settings.USEPAUSE, settings.SHOWPRESENCE, includeDurations)
        } else {
          await ExportCourseStatisticExcel(courseId, moment("2020-01-01"), moment(), exportText, settings.USEMERIT, settings.USEPAUSE, settings.SHOWPRESENCE, includeDurations)
        }
        setTimeout(() => setDownloading(false), 2000)
      } catch (error) {
        setTimeout(() => setDownloading(false), 2000)
      }

    }
  }

  return (
    <GridCard col={0} heightAuto={true} heightFix={true}>
      <Content>
        {loading ? <RainbowLoader /> :
          <>
            {!props.teacher ? <TooltipContainer>
              <Tooltip content={i18n.t(props.pinnedCourses?.some(a => a.course_id === adminSelection.id) ? "unpin-course" : "pin-course")} placement={"top-center"} offsetY={10}>
                <Pin onClick={() => props.pin(adminSelection.id, props.pinnedCourses?.some(a => a.course_id === adminSelection.id))} active={props.pinnedCourses?.some(a => a.course_id === adminSelection.id)}>
                  <PinIcon />
                </Pin>
              </Tooltip>
            </TooltipContainer>
              :
              <></>
            }
            <Export onClick={() => ExportCSV(props.course.id)}>{downloading?<RainbowLoader />:<ExcelIcon />}</Export>
            <CardFocusTitle>{i18n.t(settings.SHOWPRESENCE?"course-attendance":"course-absence")}</CardFocusTitle>
            <AbsenceContainer>
              <span><AnimatedNumber value={ShowabsenceOrAttendance(settings.SHOWPRESENCE, props.course.percent)}>%</AnimatedNumber></span>
              <p>{i18n.t(settings.SHOWPRESENCE?"attendance":"absence")}</p>
            </AbsenceContainer>
            <AbsencePraise>
              {days && days.map((d, index) => <p key={"days" + index}>{d}</p>)}
            </AbsencePraise>
            <BackgroundGraph dataPoints={dataPoints} paddingBottom={30} height={20} />
          </>
        }
      </Content>
    </GridCard>
  );
};

export default CourseStats;
